import React, { Component } from "react";
import "./outStockConfig.less";
import "@/static/style/margin.less";
import "@/static/style/init.less";
import {
  Button,
  Table,
  message,
  Modal,
  Input,
  Select,
  Upload,
  Tooltip,
  Pagination,
  Radio,
  Spin,
  Popconfirm,
  Tag,
  Checkbox
} from "antd";
import _, { get, isNumber } from "lodash";
import { ajaxApi, downloadApi } from "@/server/index";
import moment from "moment";
import common from "@/public/common";
import { getCookie, tokenConfig, formatDate } from "@/public/utils";
import { set } from "@antv/util";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { TablePipeline, features, BaseTable } from "ali-react-table";
var apiHost = common.scpUrl;
// 生成随机数
const generateUUID = () => {
  let d = new Date().getTime();
  const uuid = "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
};
class list extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      params: {
        brand_id: null,
        purchaser_id: null,
        name: "",
        di: "",
        is_bind: "",
        bind_type: "",
        page_index: 1,
        page_size: 10,
        is_stop: "",
      },
      data: [],
      supplierList: [],
      codeList: [],
      columns: [
        {
          code: "product_code",
          name: "货品信息",
          width: 300,
          lock: true,
          features: { autoRowSpan: true },
          render: (text, record) => {
            return (
              <span>
                <div>
                  <label>编码：</label>
                  {record.product_code}
                  {get(record, "is_stop_produce") &&
                  get(record, "is_stop_produce") === 1 ? (
                    <Tag color="red" style={{ marginLeft: "8px" }}>
                      停采
                    </Tag>
                  ) : (
                    ""
                  )}
                </div>
                <div style={{ marginTop: 10 }}>
                  {" "}
                  <label>采购员：</label>
                  {record.purchase_manager}
                </div>
                <div style={{ marginTop: 10 }}>
                  <label>名称：</label>
                  {record.product_name}
                </div>
                <div style={{ marginTop: 10, wordBreak: "break-all" }}>
                  <label>注册证号：</label>
                  {record.qua_code}
                </div>
              </span>
            );
          },
        },
        {
          code: "di",
          name: "DI",
          width: 160,
          render: (text, record) => {
            return (
              <span style={{ wordBreak: "break-all" }}>
                {text || "-"}
                <EditOutlined
                  style={{ color: "#1890ff", marginLeft: "4px" }}
                  onClick={() => {
                    this.openEditModal(record);
                  }}
                />
                <Popconfirm
                  title="确定删除这条di吗？"
                  onConfirm={() => {
                    this.deleteDI(record);
                  }}
                >
                  <DeleteOutlined style={{ color: "red", marginLeft: "6px" }} />
                </Popconfirm>
              </span>
            );
          },
        },
        {
          code: "di_desc",
          name: "DI产品描述",
          width: 350,
          render: (text, record) => {
            return (
              <span>
                <span style={{ fontSize: "12px", lineHeight: "1.7" }}>
                  {text || "-"}
                </span>
              </span>
            );
          },
        },
        {
          code: "di_item_name",
          name: "DI其他信息",
          width: 250,
          render: (text, record) => {
            return (
              <span>
                <div>
                  <label>商品名称：</label>
                  {record.di_item_name || "--"}
                </div>
                <div style={{ marginTop: 10 }}>
                  <label>注册人：</label>
                  {record.ylqxzcrbarmc || "--"}
                </div>
                <div style={{ marginTop: 10 }}>
                  <label>注册证号：</label>
                  {record.zczbhhzbapzbh || "--"}
                </div>
                <div style={{ marginTop: 10 }}>
                  <label>补充证号：</label>
                  {record.erp_mdrc || "--"}
                </div>
              </span>
            );
          },
        },
        {
          code: "without_bind_qua_code_list",
          name: "未绑定的注册证号",
          width: 150,
          getCellProps: (text, record) => {
            return {
              rowSpan: record.span,
            };
          },
          // render: (text, record) => {
          //     return (text && (get(text, 'length') !== 0)) ? text.map(i => <div>{i}</div>):'-'
          // }
        },
        {
          code: "is_bind",
          name: "状态",
          width: 100,
          getCellProps: (text, record) => {
            return {
              rowSpan: record.span,
            };
          },
          render: (text, record) => {
            return (
              <span>
                <span style={{ color: this.getColor(text) }}>{text}</span>
              </span>
            );
          },
        },
        {
          code: "supplier",
          name: "供应商",
          width: 250,
          getCellProps: (text, record) => {
            return {
              rowSpan: record.span,
            };
          },
          // render: (text, record) => {
          //     return (text && get(text, 'length') !== 0) ? text.map(i => <div style={{lineHeight:'1.5'}}>{i}</div>):'-'
          // }
        },
        {
          code: "mod_name",
          name: (
            <span>
              最后修改人
              <br />
              最后修改时间
            </span>
          ),
          width: 150,
          getCellProps: (text, record) => {
            return {
              rowSpan: record.span,
            };
          },
          render: (text, record) => {
            return (
              <span style={{ lineHeight: "2" }}>
                <span>{text}</span>
                {record.source && (
                  <Tag color="cyan" style={{ marginLeft: 6 }}>
                    仓库
                  </Tag>
                )}
                <br />
                <span>
                  {get(record, "mod_time")
                    ? formatDate(get(record, "mod_time"))
                    : "--"}
                </span>
              </span>
            );
          },
        },
        {
          code: "only_key",
          name: "操作",
          width: 100,
          lock: true,
          getCellProps: (text, record) => {
            return {
              rowSpan: record.span,
            };
          },
          render: (text, record) => {
            return (
              <span>
                {
                  <a
                    onClick={() => {
                      this.openBindModal(record, 1);
                    }}
                  >
                    {isNumber(get(record, "span")) ? "绑定其他DI" : "绑定"}
                  </a>
                }
              </span>
            );
          },
        },
      ],
      errorModalData: [],
      errModalVisible: false,
    };
  }
  getColor = (value) => {
    let statusObj = {
      已绑定: "green",
      待绑定: "red",
      部分绑定: "orange",
    };
    return statusObj[value] || "#ccc";
  };

  openBindModal = (record, bindOther) => {
    var modalParams = _.cloneDeep(record);
    set(modalParams, "bindOther", bindOther);
    if (bindOther) {
      set(modalParams, "di", "");
    }
    this.setState({
      bindVisible: true,
      modalParams,
    });
  };
  openEditModal = (record) => {
    this.setState({
      editVisible: true,
      modalParams: _.cloneDeep(record),
    });
  };

  componentDidMount() {
    let { params } = this.state;
    set(params, "sid", this.getSid());
    set(params, "supplier_code", this.getScode());
    this.setState({ params });
    _.defer(this.getTableData, 1000);
  }

  search = async () => {
    let { params } = this.state;
    set(params, "page_index", 1);
    this.setState({ params });
    _.defer(this.getTableData, 1000);
  };

  getTableData = async () => {
    this.changeLoading(true);
    try {
      let { params } = this.state;
      const res = await ajaxApi({
        url: `${apiHost}udi/product-udi/query-list`,
        params,
      });
      if (get(res, "data.code") == 200) {
        set(params, "total", get(res, "data.data.total", 0));
        let newData = [];
        res.data.data.data.forEach((item) => {
          const diInfoList = item.di_info_list;
          if (diInfoList && diInfoList.length > 0) {
            diInfoList.forEach((_item, index) => {
              let obj = {
                product_id: item.product_id,
                product_code: item.product_code,
                purchase_manager: item.purchase_manager,
                product_name: item.product_name,
                qua_code: item.qua_code,
                di: _item.di,
                di_desc: _item.di_desc,
                di_item_name: _item.di_item_name,
                ylqxzcrbarmc: _item.ylqxzcrbarmc,
                zczbhhzbapzbh: _item.zczbhhzbapzbh,
                erp_mdrc: _item.erp_mdrc,
                relation_id: _item.relation_id,
                without_bind_qua_code_list: item.without_bind_qua_code_list,
                is_bind: item.is_bind,
                mod_name: item.mod_name,
                mod_time: item.mod_time,
                supplier: item.supplier,
                is_stop_produce: item.is_stop_produce,
                only_key: generateUUID(),
              };
              obj.span = index === 0 ? diInfoList.length : 0;
              newData.push(obj);
            });
          } else {
            let obj = {
              product_code: item.product_code,
              purchase_manager: item.purchase_manager,
              product_name: item.product_name,
              qua_code: item.qua_code,
              without_bind_qua_code_list: item.without_bind_qua_code_list,
              is_bind: item.is_bind,
              mod_name: item.mod_name,
              mod_time: item.mod_time,
              supplier: item.supplier,
              is_stop_produce: item.is_stop_produce,
              only_key: generateUUID(),
            };
            newData.push(obj);
          }
        });
        console.log("newData", newData);
        this.setState({
          data: newData,
          params,
        });
      }

      this.changeLoading(false);
    } catch (err) {
      this.changeLoading(false);
    }
  };
  getPipeline = () => {
    const pipeline = new TablePipeline({
      state: this.state.pipelineState,
      setState: (updater) => {
        this.setState((prev) => ({
          pipelineState: updater(prev.pipelineState),
        }));
      },
    });
    pipeline.input({
      dataSource: get(this.state, "data"),
      columns: this.state.columns,
    });
    pipeline.primaryKey("only_key");
    pipeline.use(features.autoRowSpan());
    return pipeline;
  };
  getSid = () => {
    return getCookie("supplierinfo")
      ? JSON.parse(getCookie("supplierinfo")).sid
      : null;
  };
  getScode = () => {
    return getCookie("supplierinfo")
      ? JSON.parse(getCookie("supplierinfo")).code
      : null;
  };

  changeLoading = (loading) => {
    this.setState({ loading });
  };

  iptChange = (e) => {
    let { params } = this.state;
    set(params, e.target.name, e.target.value.trim());
    this.setState({
      params,
    });
  };

  iptChangeModal = (e) => {
    let { modalParams } = this.state;
    set(modalParams, e.target.name, e.target.value.trim());
    this.setState({
      modalParams,
    });
  };

  selectChange = (key, value) => {
    let { params } = this.state;
    set(params, key, value);
    this.setState({
      params,
    });
  };

  radioChange = (key, e) => {
    let { params } = this.state;
    var val = e
    set(params, key, val);
    this.setState({
      params,
    });
  };

  exportExcel = () => {
    let { params } = this.state;
    downloadApi(
      apiHost + "udi/product-udi/download-relation",
      params,
      "视客货品绑定产品标识（DI）" + moment().format("YYYYMMDDHHmmss") + ".xls"
    );
  };

  downloadTemplate = () => {
    downloadApi(
      apiHost + "udi/product-udi/download-template",
      null,
      "视客货品产品标识（DI）模板" + moment().format("YYYYMMDDHHmmss") + ".xls"
    );
  };

  getModerId = () => {
    var moder_id = getCookie("accountId")
      || "";
    return moder_id;
  };

  // 页数据修改
  onShowSizeChange = (current, pageSize) => {
    try {
      let { params } = this.state;
      set(params, "page_size", pageSize);
      set(params, "page_index", current);
      this.setState(
        {
          params,
        },
        () => {
          this.getTableData();
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  handleBind = async () => {
    let { modalParams } = this.state;
    if (!get(modalParams, "product_code")) {
      message.error("请输入货品编码");
      return;
    }
    if (!get(modalParams, "di")) {
      message.error("请输入DI");
      return;
    }
    try {
      var params = {
        di: get(modalParams, "di"),
        product_code: get(modalParams, "product_code"),
        moder: 10,
        sid: this.getSid(),
        supplier_code: this.getScode(),
      };
      const res = await ajaxApi({
        url: `${apiHost}udi/product-udi/insert-relation`,
        params,
      });
      if (res.data.code == 200) {
        message.success("操作成功");
        this.getTableData();
      } else {
        message.error(res.data.message);
      }
    } catch (err) {}
  };
  deleteDI = async (record) => {
    try {
      var params = {
        di: record.di,
        product_id: record.product_id,
        moder: 10,
        sid: this.getSid(),
        supplier_code: this.getScode(),
      };
      const res = await ajaxApi({
        url: `${apiHost}udi/product-udi/delete-relation`,
        params,
      });
      if (res.data.code == 200) {
        message.success("操作成功");
        this.getTableData();
      } else {
        message.error(res.data.message);
      }
    } catch (err) {}
  };
  handleEdit = async () => {
    let { modalParams } = this.state;
    if (!get(modalParams, "product_code")) {
      message.error("请输入货品编码");
      return;
    }
    if (!get(modalParams, "di")) {
      message.error("请输入DI");
      return;
    }
    try {
      var params = {
        di: get(modalParams, "di"),
        product_code: get(modalParams, "product_code"),
        moder: 10,
        relation_id: get(modalParams, "relation_id"),
        sid: this.getSid(),
        supplier_code: this.getScode(),
      };
      const res = await ajaxApi({
        url: `${apiHost}udi/product-udi/update-relation`,
        params,
      });
      if (res.data.code == 200) {
        message.success("操作成功");
        this.getTableData();
      } else {
        message.error(res.data.message);
      }
      this.setState({
        editVisible: false,
        modalParams: "",
      });
    } catch (err) {}
  };

  handleCancel = () => {
    this.setState({
      bindVisible: false,
      editVisible: false,
      modalParams: {},
      errModalVisible: false,
    });
  };

  render() {
    let { params, modalParams, errorModalData } = this.state;

    const personProps = {
      name: "file",
      action: apiHost + "udi/product-udi/upload-relation",
      headers: { ...tokenConfig },
      data: (file) => {
        return {
          moder: 10,
          sid: this.getSid(),
          supplier_code: this.getScode(),
        };
      },
      accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      beforeUpload: (file) => {
        if (
          ![
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel",
          ].includes(file.type)
        ) {
          message.error("请上传excel文件！");
        }
        return [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ].includes(file.type)
          ? true
          : Upload.LIST_IGNORE;
      },
      onChange: (info) => {
        if (info.file.status !== "uploading") {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === "done") {
          var data = get(info, "file.response.data");
          if (get(data, "data.length")) {
            this.setState({
              errorModalData: data,
              errModalVisible: true,
            });
          } else if (
            get(info, "file.response.message") &&
            ![0, 200].includes(get(info, "file.response.code"))
          ) {
            message.error(get(info, "file.response.message"));
          } else {
            message.success(`${info.file.name}导入成功`);
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          }
        } else if (info.file.status === "error") {
          message.error(`${info.file.name}导入失败`);
        }
      },
    };
    return (
      <div className="purchaseAdjustList outStockConfig">
        <section className="search mb20">
          {/* <h3>视客货品绑定产品标识（DI）</h3> */}
          <div>
            <Input
              placeholder="货品编码、名称"
              className="width_300_input"
              onChange={this.iptChange}
              name="product_name"
              value={get(params, "product_name")}
            />
            <Input
              placeholder="商品编码、名称"
              className="width_300_input"
              onChange={this.iptChange}
              name="item_name"
              value={get(params, "item_name")}
              style={{ marginLeft: 12 }}
            />
            <Input
              placeholder="DI"
              className="width_200_input mr12"
              onChange={this.iptChange}
              name="di"
              style={{ marginLeft: 12 }}
              value={get(params, "di")}
            />
            <Select
              placeholder="是否停采"
              style={{ marginLeft: 12, width: 100 }}
              allowClear
              options={[
                { value: 1, label: "是" },
                { value: 0, label: "否" },
              ]}
              onChange={this.selectChange.bind(this, "is_stop")}
            />
            <span style={{ marginLeft: 12 }}>状态：</span>
            <Checkbox.Group
              options={[
                { value: "irRelevant", label: "待绑定" },
                { value: "complete", label: "已绑定" },
                { value: "part", label: "部分绑定" },
              ]}
              value={get(params, "is_bind_list")}
              onChange={this.radioChange.bind(this, "is_bind_list")}
            />
            <Button type="primary" className="mr16" onClick={this.search}>
              查询
            </Button>
            <Button
              className="mr16"
              onClick={() => {
                window.location.reload();
              }}
            >
              重置
            </Button>
            <Button type="primary" onClick={this.exportExcel}>
              导出
            </Button>
            <span className={"noProgressUplaod"}>
              <Upload {...personProps}>
                <Button className={"ml16"}>Excel导入</Button>
              </Upload>
            </span>
            <a className="ml16" onClick={this.downloadTemplate}>
              下载模板
            </a>
          </div>
        </section>
        <Spin spinning={this.state.loading}>
          <div style={{ overflow: "hidden" }} className="tableBody">
            <BaseTable {...this.getPipeline().getProps()} />
            <div style={{ float: "right" }} className="mt20">
              <Pagination
                current={get(params, "page_index")}
                showQuickJumper
                total={get(params, "total")}
                pageSize={get(params, "page_size")}
                showSizeChanger
                showTotal={() => {
                  return (
                    <span style={{ marginRight: "20px", float: "left" }}>
                      共{get(params, "total")}条，每页{get(params, "page_size")}
                      条
                    </span>
                  );
                }}
                onShowSizeChange={this.onShowSizeChange}
                onChange={this.onShowSizeChange}
              />
            </div>
          </div>
        </Spin>
        <Modal
          title={get(modalParams, "bindOther") ? "绑定其他DI" : "绑定DI"}
          open={this.state.bindVisible}
          onOk={this.handleBind}
          onCancel={this.handleCancel}
        >
          <span className="ml12">货品编码：</span>
          <Input
            placeholder="请输入"
            className="width_150_input"
            onChange={this.iptChangeModal}
            name="product_code"
            value={get(modalParams, "product_code")}
            disabled={true}
          />
          <span className="ml12">DI：</span>
          <Input
            placeholder="请输入"
            className="width_150_input"
            onChange={this.iptChangeModal}
            name="di"
            value={get(modalParams, "di")}
          />
        </Modal>
        <Modal
          title={"修改已绑定DI"}
          visible={this.state.editVisible}
          onOk={this.handleEdit}
          onCancel={this.handleCancel}
        >
          <span className="ml12">货品编码：</span>
          <Input
            placeholder="请输入"
            className="width_150_input"
            onChange={this.iptChangeModal}
            name="product_code"
            value={get(modalParams, "product_code")}
            disabled={true}
          />
          <span className="ml12">DI：</span>
          <Input
            placeholder="请输入"
            className="width_150_input"
            onChange={this.iptChangeModal}
            name="di"
            value={get(modalParams, "di")}
          />
        </Modal>
        <Modal
          title="导入结果"
          open={this.state.errModalVisible}
          width={650}
          onCancel={this.handleCancel}
          footer={[
            <Button key="back" type="primary" onClick={this.handleCancel}>
              我知道了
            </Button>,
          ]}
        >
          <div style={{ maxHeight: "300px", overflow: "auto" }}>
            <div style={{ color: "#1890ff", fontWeight: 550 }}>
              共处理{get(errorModalData, "total_size")}条数据，
              {get(errorModalData, "success_size")}条成功，
              <span style={{ color: "red" }}>
                其中有{get(errorModalData, "fail_size")}条数据导入失败：
              </span>
            </div>
            {(get(errorModalData, "data") || []).map((item, index) => {
              return (
                <div key={index} style={{ marginTop: "8px" }}>
                  {item}
                </div>
              );
            })}
          </div>
        </Modal>
      </div>
    );
  }
}

export default list;



// WEBPACK FOOTER //
// ./src/pages/udi/bindUdi.js